import React, { useState, useEffect } from 'react';
import '../pages/AdminDashboard.css';

const VistaDistribuidores = () => {
  const [distribuidores, setDistribuidores] = useState([]);
  const [cargando, setCargando] = useState(true);
  
  // Estados para el formulario modal
  const [modalAbierto, setModalAbierto] = useState(false);
  const [distribuidorEditando, setDistribuidorEditando] = useState(null);
  const [formData, setFormData] = useState({
    codigo: '',
    descuento: '0.6', // Cambiado a 0.6 directo
    limite_mensual_kg: '400'
  });

  const urlBaseAPI = 'https://api.pascolo.com.ar/api/admin/distribuidores';

  const fetchDistribuidores = async () => {
    setCargando(true);
    try {
      const respuesta = await fetch(urlBaseAPI);
      const data = await respuesta.json();
      if (Array.isArray(data)) {
        setDistribuidores(data);
      } else {
        setDistribuidores([]);
      }
    } catch (error) {
      console.error("Error al cargar distribuidores:", error);
      setDistribuidores([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchDistribuidores();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const abrirModalNuevo = () => {
    setDistribuidorEditando(null);
    setFormData({ codigo: '', descuento: '0.6', limite_mensual_kg: '400' });
    setModalAbierto(true);
  };

  const abrirModalEditar = (dist) => {
    setDistribuidorEditando(dist);
    setFormData({
      codigo: dist.codigo,
      descuento: dist.descuento,
      limite_mensual_kg: dist.limite_mensual_kg
    });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setDistribuidorEditando(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.codigo.trim().length !== 6) {
      alert("El código debe tener exactamente 6 caracteres.");
      return;
    }

    const esEdicion = distribuidorEditando !== null;
    const url = esEdicion ? `${urlBaseAPI}/${distribuidorEditando.id}` : urlBaseAPI;
    const metodo = esEdicion ? 'PUT' : 'POST';

    try {
      const respuesta = await fetch(url, {
        method: metodo,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await respuesta.json();

      if (respuesta.ok) {
        cerrarModal();
        fetchDistribuidores();
      } else {
        alert(data.error || "Hubo un error al guardar el distribuidor.");
      }
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  const handleEliminar = async (id, codigo) => {
    const confirmar = window.confirm(`¿Estás seguro de que querés eliminar al distribuidor con código ${codigo}?`);
    if (!confirmar) return;

    try {
      const respuesta = await fetch(`${urlBaseAPI}/${id}`, {
        method: 'DELETE'
      });
      
      if (respuesta.ok) {
        fetchDistribuidores();
      } else {
        const data = await respuesta.json();
        alert(data.error || "No se pudo eliminar el distribuidor.");
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  if (cargando) return <p>Cargando distribuidores...</p>;

  return (
    <div className="vista-distribuidores">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>Códigos de Distribuidores</h2>
        <button 
          onClick={abrirModalNuevo}
          style={{ backgroundColor: '#2d5a27', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          + Agregar Distribuidor
        </button>
      </div>

      <div className="tabla-container" style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '15px' }}>ID</th>
              <th style={{ padding: '15px' }}>Código</th>
              <th style={{ padding: '15px' }}>Descuento</th>
              <th style={{ padding: '15px' }}>Límite Mensual</th>
              <th style={{ padding: '15px', textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {distribuidores.map((dist) => (
              <tr key={dist.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>#{dist.id}</td>
                <td style={{ padding: '15px', fontWeight: 'bold', letterSpacing: '1px' }}>{dist.codigo}</td>
                
                {/* --- CELDA LIMPIA CON EL VALOR CRUDO --- */}
                <td style={{ padding: '15px', fontWeight: 'bold', color: '#2d5a27' }}>
                  {dist.descuento}
                </td>
                
                <td style={{ padding: '15px', fontWeight: 'bold' }}>{Number(dist.limite_mensual_kg).toLocaleString('es-AR')} kg / mes</td>
                <td style={{ padding: '15px', textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                  <button 
                    onClick={() => abrirModalEditar(dist)}
                    style={{ background: '#009ee3', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    Editar
                  </button>
                  <button 
                    onClick={() => handleEliminar(dist.id, dist.codigo)}
                    style={{ background: '#f44336', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    Quitar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* --- MODAL FORMULARIO --- */}
      {modalAbierto && (
        <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
          <div className="modal-card" style={{ backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '450px', maxWidth: '90%', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
            <h3 style={{ marginTop: 0, borderBottom: '2px solid #2d5a27', paddingBottom: '10px', color: '#333' }}>
              {distribuidorEditando ? 'Editar Distribuidor' : 'Nuevo Distribuidor'}
            </h3>
            
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
              
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Código (6 dígitos)</label>
                <input 
                  type="text" 
                  name="codigo" 
                  maxLength={6}
                  placeholder="EJ: PASC02"
                  value={formData.codigo} 
                  onChange={handleInputChange} 
                  required 
                  disabled={distribuidorEditando !== null} 
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box', textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: '1px' }} 
                />
              </div>

              {/* --- ETIQUETA SIMPLIFICADA --- */}
              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Descuento</label>
                <input 
                  type="number" 
                  step="0.01" 
                  min="0" 
                  name="descuento" 
                  value={formData.descuento} 
                  onChange={handleInputChange} 
                  required 
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} 
                />
              </div>

              <div>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px', fontSize: '14px' }}>Límite Mensual (kg)</label>
                <input 
                  type="number" 
                  name="limite_mensual_kg" 
                  value={formData.limite_mensual_kg} 
                  onChange={handleInputChange} 
                  required 
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }} 
                />
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button type="submit" style={{ flex: 1, padding: '12px', backgroundColor: '#2d5a27', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                  Guardar
                </button>
                <button type="button" onClick={cerrarModal} style={{ flex: 1, padding: '12px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                  Cancelar
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default VistaDistribuidores;